import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Footer from '../core/Layout/Footer';
import { Card } from '../components/Card/Card';
import { CardBody } from '../components/Card/CardBody';
import Typography from '@material-ui/core/Typography';
import image from '../img/bg1.jpg';
import Divider from '@material-ui/core/Divider';
import { BlogCard } from '../components/Blog/BlogCard';
import {db} from "../firebase";

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  name: {
    color: '#3C4858',
    margin: '20px auto',
    fontWeight: 700,
    letterSpacing: '0.05em',
  },
  position: {
    margin: '20px auto ',
    fontSize: '1rem',
    color: '#3C4858',
  },
  function: {
    textTransform: 'uppercase',
    margin: '0 auto 20px',
    fontSize: '1rem',
    fontWeight: 400,
    color: '#3C4858',
  },
  description: {
    color: '#999',
    margin: '1.071rem auto 0',
    fontSize: '1rem',
    fontWeight: 400,
  },
  socialContainer: {
    padding: '10px 0',
  },
  facebook: {
    margin: '0 1rem',
    transition: 'transform 250ms',
    display: 'inline-block',
    color: '#4968ad',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  instagram: {
    margin: '0 1rem',
    transition: 'transform 250ms',
    display: 'inline-block',
    color: '#CC2685',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  linkedin: {
    margin: '0 1rem',
    transition: 'transform 250ms',
    display: 'inline-block',
    color: '#0A65C0',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  avatar: {
    margin: '10px 0 10px auto',
    color: theme.palette.secondary.main,
    backgroundColor: 'white',
    alignItems: 'left',
  },
  gridItem: {
    margin: '30px auto',
  },
  subCardHeader: {
    textAlign: 'left',
    color: 'white',
    fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
    marginLeft: '20px',
  },
  subCardHeaderGrid: {
    margin: 'auto 0',
  },
  contentHeading: {
    textAlign: 'left',
    margin: '20px auto 0',
    fontSize: '1rem',
    fontWeight: 700,
    color: '#3C4858',
  },
  contentSubHeading: {
    textAlign: 'left',
    textTransform: 'uppercase',
    margin: '0 auto 20px',
    fontSize: '0.75rem',
    fontWeight: 400,
    color: '#999',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  formInput: {
    margin: '10px',
  },
  resource: {
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
    background: 'rgba(0, 0, 0, 0.5)' /* Black see-through */,
    color: '#f1f1f1',
    opacity: '1',
    padding: '20px',
    textAlign: 'center',
    width: '100%',
    height: '50vh',
    top: '0',
    left: '0',
  },
  image: {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50vh',
    width: '100%',
  },
  heading: {
    marginTop: '10vh',
    fontWeight: 800,
    [theme.breakpoints.down('sm')]: {
      fontSize: '30px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '50px',
    },
  },
  cardRoot: {
    position: 'relative',
    marginTop: '-100px',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '0 50px',
    },
  },
  cardSecondary: {
    position: 'relative',
    marginTop: '20px',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '10px 50px',
    },
  },
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  carousal: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '250px',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '500px',
    },
    margin: '20px auto',
  },
  accordionHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export const Blog = () => {
  const classes = useStyles();
  const [blogPosts, setBlogPosts] = useState<any>();
  useEffect(() => {
    const getBlogs = async () => {
      let blogInfo =[];
      const blogs = await db.collection('blogs').get();
      blogs.forEach((doc) => {
        blogInfo.push({...doc.data(), id: doc.id});
      });
      setBlogPosts(blogInfo);
      console.log((blogInfo));
      return blogs
    };
    getBlogs();
  },[])
  return (
    <Grid container component="main" className={classes.container}>
      <Grid item xs={12}>
        <div className={classes.resource}>
          <div className={classes.image} />
          <div className={classes.overlay}>
            <Typography variant="h5" align="center" className={classes.heading}>
              Welcome to the Blog
            </Typography>
            <Divider
              variant="inset"
              light
              style={{
                backgroundColor: 'white',
                width: '50%',
                margin: '20px auto',
              }}
            />
            <Typography variant="h6" align="center">
              Energy Conservation & Community Education
            </Typography>
          </div>
        </div>
      </Grid>
      <Grid item xs={11}>
        <Card className={classes.cardRoot} elevation={2}>
          <CardBody style={{ padding: '20px' }}>
            <Grid container spacing={3}>
              {blogPosts &&
                  blogPosts.map(blog =>
                    <Grid item xs={12} lg={4}>
                      <BlogCard blogDetails={blog}/>
                    </Grid>
                  )
              }
            </Grid>
          </CardBody>
        </Card>
      </Grid>
      <Grid item lg={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};
